﻿<template>
  <section v-if="viewModel !== null" data-test-component="quickQuoteBasket" data-page-type="no-header">
    <page-spinner :spinner-url-list="spinnerUrlList" />

    <div data-page-type="flow">
      <!-- Sitecore Placeholder "phRightDesktopTopMobile" -->
      <slot name="topmobile" />

      <div v-cloak id="mainView" class="flow__body row container">
        <div class="small-12 medium-12 large-6 columns">
          <h1 data-test="quickquote-basket-headline" v-html="viewModel.Content.Title" />
          <div v-if="viewModel.Data.QuickQuotes.length > 0">
            <div class="basket">
              <div
                v-for="(quickquote, index) in viewModel.Data.QuickQuotes"
                :key="index"
                class="basket-item"
              >
                <!--- BASKET QUOTE PRODUCT TITLE & TRASHBUTTON --->
                <section data-page-type="no-header">
                  <div class="row collapse">
                    <h3 class="small-9 columns header-with-icon">
                      <span
                        :class="'icon-large policy-type-name-' + quickquote.Type.replace('_', '')"
                        data-test="quickquote-basket-title-icon"
                      />
                      <span data-test="quickquote-basket-title-text">
                        {{ quickquote.Name }}
                        <span
                          v-if="viewModel.Content.DigitalBonusLabel !== ''"
                          v-html="'<br />' + viewModel.Content.DigitalBonusLabel"
                        />
                        <tooltip :content="viewModel.Content.DigitalBonusTooltip" />
                      </span>
                    </h3>
                    <div class="columns small-3 text-right align-self-middle">
                      <a
                        class="link-icon"
                        data-test="quickquote-basket-button-remove"
                        @click="removeQuickQuote(index)"
                      ><span title="Slet" class="icon-trash" /></a>
                    </div>
                  </div>
                </section>
                <!--- BASKET QUOTE ASSET --->
                <section>
                  <h4 data-test="quickquote-basket-asset-title" v-html="quickquote.AssetTitle" v-if="quickquote.AssetTitle !== ''" />
                  <p data-test="quickquote-basket-asset-detail">
                    {{ quickquote.Asset.AssetDetailLines[0] }}
                  </p>
                </section>
                <!--- BASKET QUOTE COVERS --->
                <section>
                  <h4
                    data-test="quickquote-basket-cover-title"
                    v-html="viewModel.Content.LabelSelectedCoversandTooltip"
                  />
                  <ul class="no-bullet">
                    <li
                      v-for="(cover, index) in quickquote.Covers"
                      :key="index"
                      data-test-cover
                      :data-test="'quickquote-basket-cover-' + index"
                    >
                      <span v-if="isAmountCover(cover) || isStaticCoverWithValue(cover)">{{ cover.Name }}: {{ cover.Value }}</span>
                      <span
                        v-else-if="isGroupedCover(cover)"
                        v-html="cover.GroupedCovers[0].Name"
                      />
                      <span v-else v-html="cover.Name" /><tooltip
                        v-if="cover.HasTooltip"
                        :content="cover.Tooltip"
                      />
                    </li>
                    <!--- BASKET QUOTE MAIN DEDUCTIBLE --->
                    <template v-if="quickquote.HasMainDeductible">
                      <li>&nbsp;</li>
                      <li
                        data-test-deductible
                        v-html="
                          viewModel.Content.LabelDeductible + ': ' + quickquote.MainDeductibleAmount
                        "
                      />
                    </template>
                  </ul>
                </section>
                <!--- BASKET QUOTE CLAUSES --->
                <section v-if="quickquote.Clauses.length">
                  <p>
                    <a
                      class="round-arrow-with-text"
                      :data-collapse="'clauses--' + index"
                      data-test="quickquote-basket-clauses-arrow-button"
                    >
                      <span class="round-arrow down" />
                      <span data-test="quickquote-basket-clauses-title">
                        Bemærk! Der gælder særlige forhold for dit tilbud, se hvilke her
                      </span>
                    </a>
                  </p>
                  <div
                    :id="'clauses--' + index"
                    class="collapse-target"
                    data-test="quickquote-basket-clauses-content"
                  >
                    <div v-for="(clause, index) in quickquote.Clauses" :key="index">
                      <h4 v-html="clause.Title" />
                      <p v-if="clause.Description" v-html="clause.Description" />
                    </div>
                  </div>
                </section>
                <!--- BASKET QUOTE PRICE --->
                <section>
                  <div class="row collapse">
                    <strong
                      class="small-6 columns"
                      data-test="quickquote-basket-price-title"
                      v-html="viewModel.Content.LabelPrice"
                    />
                    <strong
                      class="small-6 columns text-right"
                      data-test="quickquote-basket-price"
                      v-html="
                        quickquote.Price.FormatedPriceYear + ' ' + viewModel.Content.LabelPrYear
                      "
                    />
                  </div>
                  <div class="row collapse">
                    <small
                      class="small-6 columns"
                      data-test="quickquote-basket-fee-title"
                      v-html="viewModel.Content.LabelLegalFeeandTooltip"
                    />
                    <small
                      class="small-6 columns text-right"
                      data-test="quickquote-basket-fee"
                      v-html="quickquote.Price.FormatedFee + ' ' + viewModel.Content.LabelPrYear"
                    />
                  </div>
                </section>
                <section v-if="quickquote.IsPIDPresent">
                  <ul class="no-bullet">
                    <li v-for="(pid, index) in quickquote.Data.PIDList" :key="index">
                      <a v-if="pid.PIDUrl" class="link-icon-left" :href="pid.PIDUrl"><span class="icon-download" />{{ pid.PIDText }}</a>
                    </li>
                  </ul>
                </section>
              </div>
              <!--- BASKET TOTAL PRICE OF ALL QUOTES --->
              <section class="basket-item">
                <div class="row collapse">
                  <strong
                    class="small-6 columns"
                    data-test="quickquote-basket-totalprice-inline-title"
                    v-html="viewModel.Content.LabelTotalPrice"
                  />
                  <strong
                    class="small-6 columns text-right lead"
                    data-test="quickquote-basket-totalprice-inline"
                    v-html="viewModel.Data.PriceYearTotal + ' ' + viewModel.Content.LabelPrYear"
                  />
                </div>
                <div class="row collapse align-middle padding-top">
                  <small
                    class="small-6 columns"
                    data-test="quickquote-basket-totalfee-inline-title"
                    v-html="viewModel.Content.LabelTotalFeesandTooltip"
                  />
                  <small
                    class="small-6 columns text-right"
                    data-test="quickquote-basket-totalfee-inline"
                    v-html="viewModel.Data.FeeTotal + ' ' + viewModel.Content.LabelPrYear"
                  />
                </div>
              </section>
            </div>

            <div class="row push-up">
              <div class="small-12 columns" v-html="viewModel.Content.ContentContinue" />

              <div class="small-12 medium-6 columns">
                <button
                  class="button large"
                  data-test="quickquote-basket-button-add-quickquote"
                  @click="showAddProductModal"
                  v-html="viewModel.Content.OverlayButtonText"
                />
              </div>
              <div class="small-12 medium-6 columns">
                <a
                  class="button large"
                  data-test="quickquote-basket-button-continue"
                  @click="continueClick"
                  v-html="viewModel.Content.LocalContent.LabelButtonContinue"
                />
              </div>
            </div>
          </div>

          <div v-else>
            <div>
              <h2
                data-test="quickquote-basket-empty-title"
                v-html="viewModel.Content.LabelNoItems"
              />

              <div class="row push-up">
                <div class="small-12 medium-6 columns">
                  <button
                    class="button large"
                    data-test="quickquote-basket-empty-add-quickquote"
                    @click="showAddProductModal"
                    v-html="viewModel.Content.OverlayButtonText"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="small-12 medium-12 large-6 columns">
          <sticky-basket :name="name" :price="viewModel.Data.PriceYearTotal">
            <template #label-mobile>
              <span
                data-test="quickquote-basket-totalprice-mobile"
                v-html="viewModel.Content.LabelTotalPrice"
              />
            </template>
            <template #label>
              <span
                data-test="quickquote-basket-totalprice"
                v-html="viewModel.Content.LabelTotalPrice"
              />
            </template>
            <template #basketsendoffer>
              <div v-if="showSendOfferButton" slot="" class="push-up">
                <a
                  :href="viewModel.Content.SendOfferLink.Url"
                  class="button large secondary iconbutton"
                  data-test="quickquote-basket-send-offer-link"
                  @click="dispatchSendOfferButtonClick"
                >
                  <span class="icon icon-heart" />
                  <span v-html="viewModel.Content.SendOfferLink.Text" />
                </a>
              </div>
            </template>
          </sticky-basket>

          <div class="row" v-if="showPersonalAssistance">
            <div class="small-12 medium-12 large-10 large-offset-2 columns">
              <personal-assistance :data-source="viewModel.Content.PersonalAssistanceDataSource" />
            </div>
          </div>

          <div class="row">
            <!-- Sitecore Placeholder "phRightDesktopTopMobile" -->

            <div class="small-12 medium-12 large-10 large-offset-2 columns">
              <slot name="rightcolumn" />
            </div>
          </div>
        </div>
      </div>

      <transition v-cloak name="modal">
        <v-modal
          :is-open="showMemberModal"
          data-test="quickquote-basket-modal-member"
          @close="showMemberModal = false"
        >
          <template #title>
            <h2 v-html="viewModel.Content.LocalContent.HeadlineModalMember" />
          </template>
          <template #content>
            <div slot="content">
              <div
                v-if="viewModel.Content.LocalContent.DescriptionAboveButtons"
                data-test-description-above-buttons
                class="push-down"
              >
                <p v-html="viewModel.Content.LocalContent.DescriptionAboveButtons" />
              </div>
              <div class="row">
                <div class="small-6 columns">
                  <a
                    class="button large close-modal"
                    data-test="quickquote-basket-button-member-yes"
                    @click="
                      purchase(viewModel.Content.ModalExistingMemberUrl);
                      pushToTagManager('03 kurv har haft forsikring', 'ja');
                    "
                    v-html="viewModel.Content.ModalExistingMemberText"
                  />
                </div>
                <div class="small-6 columns">
                  <a
                    class="button large close-modal"
                    data-test="quickquote-basket-button-member-no"
                    @click="
                      purchase(viewModel.Content.ModalUnknownMemberUrl);
                      pushToTagManager('03 kurv har haft forsikring', 'nej');
                    "
                    v-html="viewModel.Content.ModalUnknownMemberText"
                  />
                </div>
              </div>
            </div>
          </template>
          <template #footer />
        </v-modal>
      </transition>

      <transition v-cloak name="modal">
        <v-modal
          :is-open="removeQuickQuoteModal"
          data-test="quickquote-basket-modal-remove"
          @close="removeQuickQuoteCancel"
        >
          <template #title>
            <h2 v-html="viewModel.Content.HeadlineModalRemove" />
          </template>
          <template #content>
            <div>
              <div class="row">
                <div class="small-6 columns">
                  <button
                    class="button large"
                    data-test="quickquote-basket-button-remove-confirm"
                    @click="removeQuickQuoteConfirm"
                    v-html="viewModel.Content.LabelModalRemoveYes"
                  />
                </div>
                <div class="small-6 columns">
                  <button
                    class="button large"
                    data-test="quickquote-basket-button-remove-cancel"
                    @click="removeQuickQuoteCancel"
                    v-html="viewModel.Content.LabelModalRemoveNo"
                  />
                </div>
              </div>
            </div>
          </template>
          <template #buttons />
        </v-modal>
      </transition>

      <transition v-cloak v-if="viewModel.Content.HeadlineModalRemoveSuccess !== ''" name="modal">
        <v-modal
          :is-open="removeQuickQuoteSuccessModal"
          data-test="quickquote-basket-modal-remove-error"
          @close="removeQuickQuoteSuccessModal = false"
        >
          <template #title>
            <h2 v-html="viewModel.Content.HeadlineModalRemoveSuccess" />
          </template>
          <template #content>
            <div v-html="viewModel.Content.TextModalRemoveSuccess" />
          </template>
          <template #buttons>
            <div>
              <button
                class="button large"
                @click="removeQuickQuoteSuccessModal = false"
                v-html="viewModel.Content.LabelButtonModalRemoveSuccess"
              />
            </div>
          </template>
        </v-modal>
      </transition>

      <transition v-cloak name="modal">
        <v-modal
          :is-open="removeQuickQuoteErrorModal"
          data-test="quickquote-basket-modal-remove-error"
          @close="removeQuickQuoteErrorModal = false"
        >
          <template #title>
            <h2 v-html="viewModel.Content.HeadlineModalRemoveError" />
          </template>
          <template #content>
            <div v-html="viewModel.Content.TextModalRemoveError" />
          </template>
          <template #buttons>
            <div>
              <button
                class="button large"
                @click="removeQuickQuoteErrorModal = false"
                v-html="viewModel.Content.LabelButtonModalRemoveError"
              />
            </div>
          </template>
        </v-modal>
      </transition>

      <transition v-cloak name="modal">
        <v-modal
          :is-open="errorModal"
          data-test="quickquote-basket-modal-error"
          @close="errorModal = false"
        >
          <template #title>
            <h2 slot="title" v-html="viewModel.Content.LocalContent.HeadlineModalError" />
          </template>
          <template #content>
            <div slot="content">
              <span v-html="viewModel.Content.LocalContent.TextModalError" />
              <div class="row">
                <div class="small-6 columns">
                  <button
                    class="button large"
                    @click="errorModal = false"
                    v-html="viewModel.Content.LocalContent.LabelButtonModalError"
                  />
                </div>
              </div>
            </div>
          </template>
          <template #footer />
        </v-modal>
      </transition>

      <transition v-cloak name="modal">
        <v-modal
          :is-open="addProductModal"
          data-test="quickquote-basket-modal-add-product"
          max-width="800px"
          modal-class="alt-modal"
          @close="addProductModal = false"
        >
          <template #content>
            <navigation-list :datasource="viewModel.Content.OverlayItemId" />
          </template>
        </v-modal>
      </transition>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { forEach } from 'lodash';
import Utility from '@/common/UtilityFunctions.js';
import NavigationList from '@/components/Feature/Navigation/NavigationList.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

import PageSpinner from '@/components/UI/PageSpinner.vue';
import RequestService from '@/common/requestService';
import StickyBasket from '@/common/FlowBasket.vue';
import PersonalAssistance from '@/components/Feature/QuickQuote/PersonalAssistance/PersonalAssistance.vue';

export default {
  name: 'QuickQuoteBasket',
  components: {
    PageSpinner,
    PersonalAssistance,
    NavigationList,
    StickyBasket,
    Tooltip
  },
  props: {
    initialVueModel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      viewModel: this.initialVueModel,
      name: '',
      showMemberModal: false,
      removeQuickQuoteModal: false,
      removeQuickQuoteSuccessModal: false,
      removeQuickQuoteErrorModal: false,
      quickQuoteToRemove: null,
      errorModal: false,
      addProductModal: false,
      config: {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    };
  },
  computed: {
    spinnerUrlList() {
      return [Utility.constants().API.quickquote_ready, Utility.constants().API.quickquote_delete];
    },
    quickQuoteListForTagManager() {
      const quickQuoteListArray = [];
      forEach(this.viewModel.Data.QuickQuotes, (quickQuote) => {
        quickQuoteListArray.push(this.getDanishQuickQuoteTypeName(quickQuote));
      });
      // return Object.assign({}, quickQuoteListArray);
      return quickQuoteListArray.join(', ');
    },
    // Send offer button test
    showSendOfferButton() {
      return (
        this.viewModel.Content.ShouldShowSendOfferButton && this.viewModel.Data.QuickQuotes.length
      );
    },
    showPersonalAssistance() {
      return this.viewModel.Content.PersonalAssistanceDataSource !== '';
    }
  },
  mounted() {
    Utility.stickyBasket();
  },
  methods: {
    goToPurchase(url) {
      if (this.viewModel.Data.IsLoggedIn) {
        this.purchase(url);
      } else {
        this.showMemberModal = true;
      }
    },
    purchase(url) {
      this.showMemberModal = false;
      axios
        .post(Utility.constants().API.quickquote_ready)
        .then(() => {
          window.location.href = url;
        })
        .catch(() => {
          this.errorModal = true;
        });
    },
    removeQuickQuote(index) {
      this.removeQuickQuoteModal = true;
      this.quickQuoteToRemove = index;
    },
    removeQuickQuoteConfirm() {
      const vm = this;
      const index = this.quickQuoteToRemove;
      const quickQuoteId = this.viewModel.Data.QuickQuotes[index].PolicyId;
      const params = { quickQuoteId };
      RequestService.delete(Utility.constants().API.quickquote_delete, {}, 'json', params)
        .then((response) => {
          this.pushToTagManager(
            '03 kurv slet forsikring',
            this.getDanishQuickQuoteTypeName(this.viewModel.Data.QuickQuotes[index])
          );
          this.$store.dispatch('Events/register', {
            event: 'product-remove-from-cart',
            id: 'ecommerce',
            vm: {
              products: [
                {
                  id: vm.viewModel.Data.QuickQuotes[index].ProductType,
                  brand: Utility.getBrandIdentifier(),
                  price: vm.viewModel.Data.QuickQuotes[index].Price.PriceYear,
                  quantity: 1
                }
              ]
            }
          });
          this.viewModel.Data.QuickQuotes.splice(index, 1);
          var responseToJson = response.data;
          this.viewModel.Data.PriceYearTotal = responseToJson.PriceYearTotal;
          this.viewModel.Data.FeeTotal = responseToJson.FeeTotal;
          this.removeQuickQuoteModal = false;
          this.removeQuickQuoteSuccessModal = true;
          this.quickQuoteToRemove = null;
        })
        .catch(() => {
          this.removeQuickQuoteModal = false;
          this.quickQuoteToRemove = null;
          this.removeQuickQuoteErrorModal = true;
        });
    },
    removeQuickQuoteCancel() {
      this.quickQuoteToRemove = null;
      this.removeQuickQuoteModal = false;
    },
    // For tag Manager
    pushToTagManager(eventAction, eventLabel = '') {
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: 'beregnerkurv',
        eventAction,
        eventLabel,
        eventValue: '0',
        eventNoninteraction: true
      });
    },
    getDanishQuickQuoteTypeName(quickQuote) {
      return Utility.getDanishTypeName(quickQuote.Type);
    },
    isAmountCover(cover) {
      return cover.AmountType;
    },
    isStaticCoverWithValue(cover) {
      return cover.RenderingType === 1 && cover.Value;
    },
    isGroupedCover(cover) {
      return cover.GroupedCovers;
    },
    showAddProductModal() {
      this.addProductModal = true;
    },
    continueClick() {
      this.goToPurchase(this.viewModel.Content.ModalExistingMemberUrl);
      this.pushToTagManager('03 kurv fortsæt til køb', this.quickQuoteListForTagManager);
    },
    // Test af "Send beregning knap"
    dispatchSendOfferButtonClick() {
      let productsArray = [];
      this.viewModel.Data.QuickQuotes.forEach((quickquote) => {
        productsArray.push(Utility.getDanishTypeName(quickquote.Type));
      });

      this.$store.dispatch('Events/register', {
        event: 'basket-send-offer-qq-basket-button-click',
        id: 'basketSendOffer',
        vm: {
          products: productsArray.join(', ')
        }
      });
    }
  }
};
</script>
../../../../common/requestService
